import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function TrustBadgeSection() {
  return <section className="py-3 px-4 bg-black border-y border-zinc-900" data-id="element-235">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-4 md:gap-8 text-center opacity-60 hover:opacity-100 transition-opacity flex-wrap" data-id="element-236">
        <div className="flex items-center gap-1.5" data-id="element-237">
          <ShieldCheck className="w-4 h-4 text-zinc-400" data-id="element-238" />
          <p className="text-white font-bold text-[11px]" data-id="element-239">Garantía 7 días</p>
        </div>
        <div className="w-px h-3 bg-zinc-700 hidden sm:block" data-id="element-240" />
        <div className="flex items-center gap-1.5" data-id="element-241">
          <Lock className="w-4 h-4 text-zinc-400" data-id="element-242" />
          <p className="text-white font-bold text-[11px]" data-id="element-243">Pago 100% Seguro</p>
        </div>
        <div className="w-px h-3 bg-zinc-700 hidden sm:block" data-id="element-244" />
        <div className="flex items-center gap-1.5" data-id="element-245">
          <CreditCard className="w-4 h-4 text-zinc-400" data-id="element-246" />
          <p className="text-white font-bold text-[11px]" data-id="element-247">Acceso Inmediato</p>
        </div>
      </div>
    </section>;
}